"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPACING = void 0;
exports.SPACING = {
    "quarck": 4,
    "nano": 8,
    "xxxs": 12,
    "xxs": 16,
    "xs": 20,
    "s": 24,
    "sm": 32,
    "md": 40,
    "lg": 48,
    "xl": 56,
    "xxl": 64,
    "xxxl": 80,
    "huge": 120,
    "giant": 160,
    /** @deprecated Use values directly from SPACING instead. E.g.: SPACING.nano */
    "stack": {
        "quarck": 4,
        "nano": 8,
        "xxxs": 16,
        "xxs": 24,
        "xs": 32,
        "sm": 40,
        "md": 48,
        "lg": 56,
        "xl": 64,
        "xxl": 80,
        "xxxl": 120,
        "huge": 160,
        "giant": 200
    },
    /** @deprecated Use values directly from SPACING instead. E.g.: SPACING.nano */
    "inset": {
        "quarck": 4,
        "nano": 8,
        "xxxs": 16,
        "xxs": 24,
        "xs": 32,
        "sm": 40,
        "md": 48,
        "lg": 56
    },
    /** @deprecated Use values directly from SPACING instead. E.g.: SPACING.nano */
    "inline": {
        "quarck": 4,
        "nano": 8,
        "xxxs": 16,
        "xxs": 24,
        "xs": 32,
        "sm": 40,
        "md": 48,
        "lg": 56,
        "xl": 64
    }
};
